import _ from 'lodash';
import { createSelector } from 'reselect';

import { PendingCorrelationMap, PropertyCorrelationMap } from 'constants/lead';
import { getPositiveValue, normalizeViewPhoneNumber } from 'utils/data';

import { selectLoanApplication } from './loanApplication.selectors';
import { selectLoanChangesHistory } from './loanChangesHistory.selectors';

export const selectLeadFromApplication = createSelector(selectLoanApplication, ({ lead }) => lead);

const entityChangesMapper = (entityLoanChangesHistory, initAcc) =>
  entityLoanChangesHistory?.reduce((acc, { propertyName, newValue, oldValue }) => {
    const { initialValue } = acc[propertyName] || {};
    const isInitialValueSet = _.has(acc, `${propertyName}.initialValue`);
    const correctedName = PendingCorrelationMap[propertyName] || propertyName;

    acc[correctedName] = {
      newValue,
      initialValue: isInitialValueSet ? initialValue : oldValue,
    };

    return acc;
  }, initAcc);

// Lead has all properties (Address, Borrower, Application) stored on one view so no need to pick by type
const selectLeadChangedProps = createSelector(selectLoanChangesHistory, applicationChangedProps =>
  Object.values(applicationChangedProps).reduce((acc, changesByEntity) => {
    entityChangesMapper(changesByEntity, acc);

    return acc;
  }, {}),
);

// BE stores property fields on top level AddressAutocomplete and Pending changes highlight
// require property fields under 'property' prop
const propertyInfoMapper = (data = {}) =>
  Object.entries(data).reduce(
    (acc, [key, value]) => {
      if (PropertyCorrelationMap[key]) {
        acc.property[PropertyCorrelationMap[key]] = value;

        return acc;
      }

      acc[key] = value;

      return acc;
    },
    { property: {} },
  );

// with mapped property fields
export const selectMappedLeadChangedProps = createSelector(
  selectLeadChangedProps,
  propertyInfoMapper,
);

// with mapped property fields
const selectMappedLeadFromApplication = createSelector(
  selectLeadFromApplication,
  propertyInfoMapper,
);

export const selectFixedLeadFromApplication = createSelector(
  selectMappedLeadFromApplication,
  ({ purchasePrice, loanAmount, propertyValue, phoneNumber, ...restLeadData }) => {
    return {
      ...restLeadData,
      purchasePrice: getPositiveValue(purchasePrice),
      loanAmount: getPositiveValue(loanAmount),
      propertyValue: getPositiveValue(propertyValue),
      phoneNumber: normalizeViewPhoneNumber(phoneNumber),
    };
  },
);
